import { ref, reactive } from "vue";
import { usePageI18n } from "@/composables/usePageI18n";
import { translateCookieToastMessage } from "@/utils/cookieErrors";

export function useAuthShell() {
  const { t } = usePageI18n();
  const isSidebarCollapsed = ref(false);
  const isSidebarOpenMobile = ref(false);
  const sidebarSearch = ref("");

  const toast = reactive({ show: false, type: "success", message: "" });
  let toastTimer;

  function toggleSidebar() {
    if (window.innerWidth < 768) {
      isSidebarOpenMobile.value = !isSidebarOpenMobile.value;
    } else {
      isSidebarCollapsed.value = !isSidebarCollapsed.value;
    }
  }

  function showToast(message, type = "success") {
    toast.message = translateCookieToastMessage(message, t);
    toast.type = type;
    toast.show = true;
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.show = false;
    }, 2500);
  }

  return {
    isSidebarCollapsed,
    isSidebarOpenMobile,
    sidebarSearch,
    toggleSidebar,
    toast,
    showToast,
  };
}
